import SectionHeading from '@/pages/home/components/SectionHeading';
import { safetyRisks } from '@/mocks/home';

const toneMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  secondary: 'bg-secondary-100 text-secondary-800',
  accent: 'bg-accent-100 text-accent-700',
};

const levelTone: Record<string, string> = {
  高: 'bg-primary-500 text-background-50',
  中: 'bg-secondary-500 text-background-50',
  低: 'bg-accent-500 text-background-50',
};

export default function SafetySection() {
  return (
    <section id="safety" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="安全性分析"
          title="神马影院安全吗？常见风险逐条拆解"
          desc="安全性问题往往不是“有没有病毒”这么简单，而是一连串具体的隐患叠加。下面把这些隐患分成六类，并标注了相对的风险高低。"
        />

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {safetyRisks.map((r) => (
            <div key={r.title} className="p-5 rounded-lg bg-background-100 border border-background-200 flex flex-col">
              <div className="flex items-center justify-between mb-4">
                <span
                  className={`w-11 h-11 flex items-center justify-center rounded-md ${toneMap[r.tone] ?? toneMap.primary}`}
                >
                  <i className={`${r.icon} text-xl`}></i>
                </span>
                <span
                  className={`text-xs font-medium px-2.5 py-1 rounded-full ${levelTone[r.level] ?? levelTone['中']}`}
                >
                  风险 {r.level}
                </span>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 text-base mb-2">{r.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-6 p-5 rounded-lg bg-accent-50 border border-accent-200 flex items-start gap-3">
          <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
            <i className="ri-lightbulb-line"></i>
          </span>
          <p className="text-sm text-foreground-700 leading-relaxed">
            <strong className="text-foreground-900 font-semibold">小结：</strong>
            以上风险中，真正可能造成实际损失的是“诱导下载”“钓鱼付款”“过度授权”三类。它们有一个共同特征——
            都需要你主动点击、下载或填写信息。保持克制，就能挡掉大部分麻烦。
          </p>
        </div>
      </div>
    </section>
  );
}